export default "__VITE_ASSET__CletBAUs__"